/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { accessAPI, tituloBase, VistaCumplimiento } from "../../shared";

// El auditor no tiene acceso a los endpoints de archivos del admin: el archivo
// se descarga por su hash, igual que la vista previa.
const rutaDescargaArchivo = (archivo) => `archivo/${archivo.hash}/download`;

/**
 * Cumplimiento del organismo con su norma de referencia, de solo lectura, para
 * consultarlo durante una auditoría del sistema de gestión.
 */
export default function Cumplimiento() {
  const [loader, setLoader] = useState(true);
  const [datos, setDatos] = useState(null);

  const toast = useRef(null);
  const { auditoriaId } = useParams();

  useEffect(() => {
    document.title = "Cumplimiento";
    accessAPI(
      "GET",
      "auditorsg/cumplimiento",
      null,
      (respuesta) => {
        setDatos(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        setLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta?.[0]?.msg || "No se pudo cargar el cumplimiento",
          sticky: true,
        });
      },
    );
    return () => (document.title = tituloBase());
  }, []);

  if (loader) {
    return (
      <>
        <Toast ref={toast} position="top-center" />
        <Skeleton width="20rem" height="2rem" css={{ marginBottom: "1em" }} />
        <Card>
          <Skeleton width="100%" height="20rem" />
        </Card>
      </>
    );
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      {datos && (
        <VistaCumplimiento
          datos={datos}
          toast={toast}
          rutaDescargaArchivo={rutaDescargaArchivo}
          urlVolver={`/auditoriasg/${auditoriaId}`}
        />
      )}
    </>
  );
}
